import React from 'react';
import autobind from 'autobind-decorator';

import {BaseComponent} from '../../BaseComponent';

export class BaseTableFilter extends BaseComponent {
    constructor() {
        super();
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        if (prevProps.Filters !== this.props.Filters) {
            this.props.Filters.forEach(x => {
                if (!x.isSet) {
                    const filter = x?.code;

                    if (filter) {
                        this.setState({[filter]: ""});
                    }
                }
            });
        }
    }

    @autobind
    updateFilters(filters) {
        if(this.props.UpdateFilters) {
            this.props.UpdateFilters(filters);
        }
    }

    @autobind
    _render() {
        return <span />;
    }

    render() {
        return this._render();
    }
}

